module.exports = __webpack_public_path__ + "img/roundup_logo.9163ff2a.svg";